import * as fire from "firebase"
import Config from "config"

export const fetchPromoCode = (stateAndProps) => {
  return (dispatch, getState, { getFirestore }) => {
    // console.log(getState);
    const firestore = getFirestore()
    return firestore
      .collection("promoCodes")
      .doc(stateAndProps.promoCode)
      .get()
      .then((doc) => {
        // This Is For Dev Purposes Only
        if (
          (Config.Env === "Staging" || Config.Env === "Local") &&
          stateAndProps.promoCode === "ERROR"
        ) {
          throw new Error("Sample Promo Code Error - In Dev Only")
        }
        // ===== ===== ===== ===== =====

        if (doc.exists) {
          const data = doc.data()
          if (data.active && data.count < data.limit) {
            return dispatch({ type: "promoCodeIsValid", data: doc.data() })
          }
        }
        return dispatch({ type: "promoCodeIsInvalid" })
      })
      .catch((err) => {
        return dispatch({ type: "promoCodeNotFetched", err })
      })
  }
}

export const incrementPromoCodeUsageCount = (stateAndProps) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore()
    return firestore
      .collection("promoCodes")
      .doc(stateAndProps.promoCode)
      .update({
        count: fire.firestore.FieldValue.increment(1),
      })
      .then(() => {
        dispatch({ type: "promoCodeUsageCountIncrement" })
      })
      .catch((err) => {
        dispatch({ type: "promoCodeUsageCountIncrement_Failed", err })
      })
  }
}

export const addPromoCode = (stateAndProps) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore()
    return firestore
      .collection("promoCodes")
      .doc(stateAndProps.title)
      .set({
        ...stateAndProps,
        count: 0,
        time: fire.firestore.FieldValue.serverTimestamp(),
      })
      .then(() => {
        console.log("Promo Code Added.")
        return true
      })
      .catch((err) => {
        console.log(`Promo Code Not Added. Error:\n${err}`)
        return false
      })
  }
}
